import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-management-dashboard',
  templateUrl: './payroll-management-dashboard.component.html',
  styleUrls: ['./payroll-management-dashboard.component.scss']
})
export class PayrollManagementDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
